import script from "./LeaseView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaseView.vue?vue&type=script&setup=true&lang=js"

import "./LeaseView.vue?vue&type=style&index=0&id=8b8af994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b8af994"]])

export default __exports__